module.exports = __webpack_public_path__ + "static/img/Elliot_Yeo_mobile.d38c3b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Elliot_Yeo_mobile.jpg
// module id = DLCd
// module chunks = 0